import { Box, Container, Grid, Paper } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import { getById } from "../../../store/user/queries";
import { Data } from "../../../store/user/types";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";

const UserView = () => {
  const classes = pageStyles();
  const session = useSession();

  const { id } = useParams<{ id: string }>();
  const user = useSelector(id ? getById(id) : () => null) as Data;
  const { attributes: at } = user;

  const userData: Item[] = [
    { fieldName: "User Status", fieldValue: at.Enabled },
    { fieldName: "First Name", fieldValue: at.FirstName },
    { fieldName: "Last Name", fieldValue: at.LastName as string },
    { fieldName: "Email", fieldValue: at.Email },
    { fieldName: "User Group", fieldValue: at.Group },
    { fieldName: "Company", fieldValue: at.Company as string },
    { fieldName: "Department", fieldValue: at.Department as string },
    { fieldName: "Phone", fieldValue: at.Phone as string },
  ];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View User" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName="User Info"
                    itemData={userData}
                    lastItem
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default UserView;
